import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AdminAuthContext } from '../AdminAuthContext';
import '../pages/SearchResults.css';

const AdminRoute = ({ children }) => {
  const { admin, loading } = useContext(AdminAuthContext);

  if (loading) {
    return (
      <div>
        <div className="search-results-loading">
          <div className="search-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!admin || admin.role !== 'admin') {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default AdminRoute;